import { render, staticRenderFns } from "./repullDataDetail.vue?vue&type=template&id=145f44a6&lang=pug&"
import script from "./repullDataDetail.vue?vue&type=script&lang=js&"
export * from "./repullDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports